import React, { useContext } from 'react'
import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import SingleSlotCard from './components/SingleSlotCard'
import LoginContext from './context'

const SingleSlot = () => {
        const {isAuthenticated}= useContext(LoginContext)
    
    return (
        <>
            <section className='single-slot'>
                <CommonBox heading=" 프라그마틱슬롯 " englishHeading="PragmaticPlay" isEnglishHeadingOnMobile={true} isAuthenticated={isAuthenticated}>
                   {isAuthenticated &&  <input type="text" name="slot_search" id="slot_search" placeholder="search" className='w-full block bg-obsidian text-center mx-auto my-[5px] text-white text-xs leading-[36px] lg:leading-[33px] h-[36px] lg:h-[33px] transition-[0.2s] align-middle px-[5px] py-0.5 rounded-none lg:rounded-[5px] border border-slate placeholder:text-[#fff4cf] lg:placeholder:text-[#757575] outline-none font-sans-serif' />}
                    <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 2xl:grid-cols-8 gap-1 lg:gap-4 p-0.5 lg:p-2'>
                        {Array.from({ length: 16 }, (_, index) => (
                            <div key={index} className='relative cursor-pointer text-center inline-block p-[5px] hover:filter hover:brightness-[1.3] transition-[0.2s] duration-200 ease-in-out '>
                                <SingleSlotCard />
                            </div>
                        ))}
                    </div>
                </CommonBox>
            </section>
                <section className='gif-section flex lg:hidden items-center justify-center'>
                    <GifImagesSection />
                </section>

        </>
    )
}

export default SingleSlot